import { compose, lifecycle, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { isEmpty, pick } from 'lodash';

import { saveMailchimpToken } from './actions';
import { Logger } from '../../../../../modules/infra/observability/logger';
import withToggle from '../../../../common/hoc/withToggle';
import withMailchimpSettings from './withMailchimpSettings';

const withMailchimpConnectionSave = compose(
  withMailchimpSettings,
  withRouter,
  withToggle('initialized', false),
  withHandlers({
    checkLocationQueryParams: ({ brandId, location, ...props }) => async () => {
      const authorizeInformation = pick(location.query, ['code']);

      if (isEmpty(authorizeInformation)) {
        return;
      }

      try {
        await saveMailchimpToken({ brandId, ...authorizeInformation });
      } catch (error) {
        Logger.error('Send Mailchimp token to backend', {
          error,
          action: 'Send Mailchimp token to backend',
        });

        return;
      } finally {
        props.fetchSettings(brandId);
      }

      props.addNotification({
        title: 'Success',
        level: 'success',
        message: 'You’ve connected to Mailchimp',
      });

      props.router.push(props.router.location.pathname);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.checkLocationQueryParams();
    },
  })
);

export default withMailchimpConnectionSave;
